import React, { Fragment } from "react";
import { useLiquitySelector } from "@liquity/lib-react";
import { CollateralBaseState, CollateralDerivedState, LiquityStoreState } from "@liquity/lib-base";
import { MySpPosition } from "./MySpPosition";
import { CollateralLexicons } from "src/lexicon";
import { merge } from "lodash";

type ResultSelector = Pick<CollateralBaseState & CollateralDerivedState, "stabilityDeposit" | "slsdInStabilityPool" | "trove"> & { key: string }

const selector = ({ collateralStates, collateralDerivedStates }: LiquityStoreState) => {
  const collStates = merge(collateralStates, collateralDerivedStates)

  const selected = Object.entries(collStates).reduce<ResultSelector[]>((acc, [key, value]) => {
    const { stabilityDeposit, slsdInStabilityPool, trove } = value

    if (!stabilityDeposit.isEmpty) {
      acc.push({ key, stabilityDeposit, slsdInStabilityPool, trove })
    }
    return acc
  }, [])
  return selected
};

export const MySpPositions: React.FC = () => {
  // NOTE: This will be multiple sp-pool in the future
  const spList = useLiquitySelector(selector);

  return (
    <div className="bg-component border-component pt-6 px-5 flex flex-col h-full">
      <div className="flex flex-row items-center justify-start mb-1">
        <div className="text-style-value">SP Position</div>
      </div>
      <div className="divide-y divide-clearWhite">
        {spList.map((spInfo, idx) => {
          const { key, stabilityDeposit, slsdInStabilityPool } = spInfo
          const lexicon = CollateralLexicons.find(lexicon => lexicon.key === key)

          return (
            <Fragment key={idx}>
              {lexicon && (
                <MySpPosition
                  collateralName={lexicon.name}
                  deposit={stabilityDeposit.currentSLSD.prettify()}
                  totalDeposit={slsdInStabilityPool.prettify(0)}
                  collateralGain={stabilityDeposit.collateralGain.prettify(2)}
                  psyReward={stabilityDeposit.psyReward}
                  lexicon={lexicon}
                  collateralKey={key}
                />
              )}
            </Fragment>
          )
        })}
      </div>
    </div>
  );
};
